export default "__VITE_ASSET__5hF_zEi3__"